import { render } from "./Results.vue?vue&type=template&id=60926951&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=60926951&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-next-gen\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60926951"]])

export default __exports__